/**
 * @generated SignedSource<<737b60594d20259e4f1875e8685ba45a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type versionStatus_softwareReleasesLaunchCard$data = {
  readonly canEdit: boolean;
  readonly hasReleaseNote?: boolean | null | undefined;
  readonly id: string;
  readonly project: {
    readonly key: string;
  };
  readonly status: JiraVersionStatus;
  readonly versionId: string;
  readonly " $fragmentType": "versionStatus_softwareReleasesLaunchCard";
};
export type versionStatus_softwareReleasesLaunchCard$key = {
  readonly " $data"?: versionStatus_softwareReleasesLaunchCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"versionStatus_softwareReleasesLaunchCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcversiondetailsshouldskipreleasenotefieldrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "versionStatus_softwareReleasesLaunchCard",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "versionId"
      },
      "action": "THROW",
      "path": "versionId"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "status"
      },
      "action": "THROW",
      "path": "status"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "key"
            },
            "action": "THROW",
            "path": "project.key"
          }
        ]
      },
      "action": "THROW",
      "path": "project"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "canEdit"
      },
      "action": "THROW",
      "path": "canEdit"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcversiondetailsshouldskipreleasenotefieldrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "hasReleaseNote"
        }
      ]
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "426b6e3ebce02eaac4cf9455dc642982";

export default node;
